// Authentication pages translations
export const authTranslations = {
  en: {
    "fields": {
      "username": "Username",
      "password": "Password",
      "email": "Email",
      "confirmPassword": "Confirm Password",
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "confirmNewPassword": "Confirm New Password"
    },
    "actions": {
      "login": "Log In",
      "register": "Register",
      "logout": "Log Out",
      "changePassword": "Change Password",
      "forgotPassword": "Forgot Password",
      "resetPassword": "Reset Password",
      "sendResetLink": "Send Reset Link",
      "forgotUsername": "Forgot Username",
      "sendUsername": "Send Username Reminder",
      "resendVerification": "Resend Verification Email",
      "sendVerificationEmail": "Send Verification Email",
      "backToLogin": "Back to Login",
      "tryAgain": "Try Again",
      "resending": "Sending..."
    },
    "messages": {
      "loggingIn": "Logging in...",
      "loginSuccess": "Login successful",
      "loginError": "Login failed",
      "registerSuccess": "Registration successful",
      "registerError": "Registration failed",
      "passwordMismatch": "Passwords do not match",
      "passwordChanged": "Password changed successfully",
      "invalidCredentials": "Invalid credentials",
      "pleaseLogin": "Please log in to continue",
      "checkEmail": "Please check your email to verify your account.",
      "checkSpam": "If you don't see the email in your inbox, please check your spam/junk folder.",
      "registrationSuccess": "Registration successful! Please check your email to verify your account.",
      "emailSendFailed": "Registration successful, but there was a problem sending the verification email. Please contact support.",
      "passwordResetSent": "If your email was registered, you will receive instructions to reset your password.",
      "passwordResetSuccess": "Password reset successful. You can now log in with your new password.",
      "usernameReminderSent": "If your email was registered, you will receive an email with your username.",
      "verificationNote": "Please be aware that it may take up to 30 minutes to receive the verification email. If you do not receive it within this timeframe, please check your junk or spam folder. If the email is not there, consider using an alternative email address. Should the issue persist, contact us at contact@qualitati.com.",
      "resendVerificationInstructions": "Enter your email address and we'll send you a new verification link. Make sure to check your spam folder.",
      "resendFailed": "Failed to resend verification email. Please try again later.",
      "incorrectCredentials": "Incorrect username/email or password. Please try again.",
      "emailNotVerified": "Please verify your email before logging in.",
      "mfaPrompt": "We emailed you a 6-digit code. Enter it below to finish signing in.",
      "mfaCodeLabel": "Verification code",
      "mfaVerify": "Verify code",
      "mfaBack": "Back to login",
      "mfaVerifying": "Verifying...",
      "mfaInvalid": "Invalid or expired code. Please try again."
    },
    "verification": {
      "verifying": "Verifying your email...",
      "redirecting": "Redirecting to login page...",
      "success": "Email verification successful!",
      "error": "Verification failed",
    }
  },
  zh: {
    "fields": {
      "username": "用户名",
      "password": "密码",
      "email": "电子邮箱",
      "confirmPassword": "确认密码",
      "currentPassword": "当前密码",
      "newPassword": "新密码",
      "confirmNewPassword": "确认新密码"
    },
    "actions": {
      "login": "登录",
      "register": "注册",
      "logout": "退出",
      "changePassword": "修改密码",
      "forgotPassword": "忘记密码",
      "resetPassword": "重置密码",
      "sendResetLink": "发送重置链接",
      "forgotUsername": "忘记用户名",
      "sendUsername": "发送用户名提醒",
      "resendVerification": "重新发送验证邮件",
      "sendVerificationEmail": "发送验证邮件",
      "backToLogin": "返回登录",
      "tryAgain": "重试",
      "resending": "发送中..."
    },
    "messages": {
      "loggingIn": "登录中...",
      "loginSuccess": "登录成功",
      "loginError": "登录失败",
      "registerSuccess": "注册成功",
      "registerError": "注册失败",
      "passwordMismatch": "密码不匹配",
      "passwordChanged": "密码修改成功",
      "invalidCredentials": "无效的凭证",
      "pleaseLogin": "请登录后继续",
      "checkEmail": "请检查您的电子邮箱（包括垃圾邮件文件夹）以获取验证链接。",
      "registrationSuccess": "注册成功！请检查您的电子邮箱以验证您的账户。",
      "emailSendFailed": "注册成功，但发送验证邮件时出现问题。请联系支持。",
      "passwordResetSent": "如果您的电子邮箱已注册，您将收到密码重置说明。",
      "passwordResetSuccess": "密码重置成功。您现在可以使用新密码登录。",
      "usernameReminderSent": "如果您的电子邮箱已注册，您将收到您的用户名。",
      "checkSpam": "如果您在收件箱中没有看到邮件，请检查您的垃圾邮件文件夹。",
      "verificationNote": "请注意，验证邮件可能需要最多30分钟才能收到。如果在此时间内未收到邮件，请检查垃圾邮件文件夹。如果仍未找到邮件，建议使用其他电子邮箱地址。如果问题仍然存在，请通过 contact@qualitati.com 与我们联系。",
      "resendVerificationInstructions": "输入您的电子邮箱地址，我们将向您发送新的验证链接。请务必检查您的垃圾邮件文件夹。",
      "resendFailed": "重新发送验证邮件失败。请稍后重试。",
      "incorrectCredentials": "用户名/邮箱或密码错误，请重试。",
      "emailNotVerified": "请先验证您的邮箱再登录。",
      "mfaPrompt": "我们已向您的邮箱发送了一个6位验证码。请在下方输入以完成登录。",
      "mfaCodeLabel": "验证码",
      "mfaVerify": "验证",
      "mfaBack": "返回登录",
      "mfaVerifying": "验证中...",
      "mfaInvalid": "验证码无效或已过期，请重试。"
    },
    "verification": {
      "verifying": "正在验证您的邮箱...",
      "redirecting": "正在跳转到登录页面...",
      "success": "电子邮箱验证成功！",
      "error": "验证失败",
    }
  },
  fr: {
    "fields": {
      "username": "Nom d'utilisateur",
      "password": "Mot de passe",
      "email": "Adresse e-mail",
      "confirmPassword": "Confirmer le mot de passe",
      "currentPassword": "Mot de passe actuel",
      "newPassword": "Nouveau mot de passe",
      "confirmNewPassword": "Confirmer le nouveau mot de passe"
    },
    "actions": {
      "login": "Se connecter",
      "register": "S'inscrire",
      "logout": "Se déconnecter",
      "changePassword": "Modifier le mot de passe",
      "forgotPassword": "Mot de passe oublié",
      "resetPassword": "Réinitialiser le mot de passe",
      "sendResetLink": "Envoyer le lien de réinitialisation",
      "forgotUsername": "Nom d'utilisateur oublié",
      "sendUsername": "Envoyer un rappel de nom d'utilisateur",
      "resendVerification": "Renvoyer l'E-mail de Vérification",
      "sendVerificationEmail": "Envoyer l'E-mail de Vérification",
      "backToLogin": "Retour à la Connexion",
      "tryAgain": "Réessayer",
      "resending": "Envoi en cours..."
    },
    "messages": {
      "loggingIn": "Connexion en cours...",
      "loginSuccess": "Connexion réussie",
      "loginError": "Échec de la connexion",
      "registerSuccess": "Inscription réussie",
      "registerError": "Échec de l'inscription",
      "passwordMismatch": "Les mots de passe ne correspondent pas",
      "passwordChanged": "Mot de passe changé avec succès",
      "invalidCredentials": "Identifiants invalides",
      "pleaseLogin": "Veuillez vous connecter pour continuer",
      "checkEmail": "Veuillez vérifier votre e-mail pour valider votre compte.",
      "checkSpam": "Si vous ne voyez pas l'e-mail dans votre boîte de réception, veuillez vérifier votre dossier spam/indésirables.",
      "registrationSuccess": "Inscription réussie ! Veuillez vérifier votre e-mail pour valider votre compte.",
      "emailSendFailed": "Inscription réussie, mais un problème est survenu lors de l'envoi de l'e-mail de vérification. Veuillez contacter l'assistance.",
      "passwordResetSent": "Si votre e-mail était enregistré, vous recevrez des instructions pour réinitialiser votre mot de passe.",
      "passwordResetSuccess": "Réinitialisation du mot de passe réussie. Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.",
      "usernameReminderSent": "Si votre e-mail était enregistré, vous recevrez un e-mail indiquant votre nom d'utilisateur.",
      "verificationNote": "Veuillez noter qu'il peut falloir jusqu'à 30 minutes pour recevoir l'e-mail de vérification. Si vous ne le recevez pas dans ce délai, veuillez vérifier votre dossier de courrier indésirable ou spam. Si l'e-mail ne s'y trouve pas, envisagez d'utiliser une autre adresse e-mail. Si le problème persiste, contactez-nous à contact@qualitati.com.",
      "resendVerificationInstructions": "Entrez votre adresse e-mail et nous vous enverrons un nouveau lien de vérification. Assurez-vous de vérifier votre dossier spam.",
      "resendFailed": "Échec du renvoi de l'e-mail de vérification. Veuillez réessayer plus tard.",
      "incorrectCredentials": "Nom d'utilisateur/e-mail ou mot de passe incorrect. Veuillez réessayer.",
      "emailNotVerified": "Veuillez vérifier votre e-mail avant de vous connecter.",
      "mfaPrompt": "Nous vous avons envoyé un code à 6 chiffres par e-mail. Saisissez-le ci-dessous pour terminer la connexion.",
      "mfaCodeLabel": "Code de vérification",
      "mfaVerify": "Vérifier le code",
      "mfaBack": "Retour à la connexion",
      "mfaVerifying": "Vérification...",
      "mfaInvalid": "Code invalide ou expiré. Veuillez réessayer."
    },
    "verification": {
      "verifying": "Vérification de votre e-mail...",
      "redirecting": "Redirection vers la page de connexion...",
      "success": "Vérification de l'e-mail réussie !",
      "error": "Échec de la vérification",
    }
  },
  nb: {
    "fields": {
      "username": "Brukernavn",
      "password": "Passord",
      "email": "E-post",
      "confirmPassword": "Bekreft passord",
      "currentPassword": "Nåværende passord",
      "newPassword": "Nytt passord",
      "confirmNewPassword": "Bekreft nytt passord"
    },
    "actions": {
      "login": "Logg inn",
      "register": "Registrer deg",
      "logout": "Logg ut",
      "changePassword": "Endre passord",
      "forgotPassword": "Glemt passord",
      "resetPassword": "Tilbakestill passord",
      "sendResetLink": "Send tilbakestillingslenke",
      "forgotUsername": "Glemt brukernavn",
      "sendUsername": "Send brukernavn påminnelse",
      "resendVerification": "Send Bekreftelses-e-post På Nytt",
      "sendVerificationEmail": "Send Bekreftelses-e-post",
      "backToLogin": "Tilbake til Innlogging",
      "tryAgain": "Prøv Igjen",
      "resending": "Sender..."
    },    "messages": {
      "loggingIn": "Logger inn...",
      "loginSuccess": "Innlogging vellykket",
      "loginError": "Innlogging mislyktes",
      "registerSuccess": "Registrering vellykket",
      "registerError": "Registrering mislyktes",
      "passwordMismatch": "Passordene stemmer ikke overens",
      "passwordChanged": "Passord endret",
      "invalidCredentials": "Ugyldig påloggingsinformasjon",
      "pleaseLogin": "Vennligst logg inn for å fortsette",
      "checkEmail": "Vennligst sjekk e-posten din for å verifisere kontoen din.",
      "checkSpam": "Hvis du ikke ser e-posten i innboksen din, vennligst sjekk spam/søppelpost-mappen din.",
      "registrationSuccess": "Registrering vellykket! Vennligst sjekk e-posten din for å verifisere kontoen din.",
      "emailSendFailed": "Registrering vellykket, men det oppstod et problem med å sende verifikasjons-e-posten. Vennligst kontakt support.",
      "passwordResetSent": "Hvis e-posten din er registrert, vil du motta instruksjoner for tilbakestilling av passord.",
      "passwordResetSuccess": "Passord tilbakestilling vellykket. Du kan nå logge inn med ditt nye passord.",
      "usernameReminderSent": "Hvis e-posten din er registrert, vil du motta brukernavnet ditt.",
      "verificationNote": "Vær oppmerksom på at det kan ta opptil 30 minutter å motta verifikasjons-e-posten. Hvis du ikke mottar den innen denne tidsrammen, vennligst sjekk søppelpost- eller spam-mappen din. Hvis e-posten ikke er der, vurder å bruke en alternativ e-postadresse. Skulle problemet vedvare, kontakt oss på contact@qualitati.com.",
      "resendVerificationInstructions": "Skriv inn e-postadressen din, så sender vi deg en ny bekreftelseslenke. Husk å sjekke spam-mappen din.",
      "resendFailed": "Kunne ikke sende bekreftelses-e-post på nytt. Vennligst prøv igjen senere.",
      "incorrectCredentials": "Feil brukernavn/e-post eller passord. Vennligst prøv igjen.",
      "emailNotVerified": "Vennligst bekreft e-posten din før du logger inn.",
      "mfaPrompt": "Vi har sendt deg en 6-sifret kode på e-post. Skriv den inn nedenfor for å fullføre innloggingen.",
      "mfaCodeLabel": "Verifiseringskode",
      "mfaVerify": "Bekreft kode",
      "mfaBack": "Tilbake til innlogging",
      "mfaVerifying": "Bekrefter...",
      "mfaInvalid": "Ugyldig eller utløpt kode. Prøv igjen."
    },
    "verification": {
      "verifying": "Verifiserer e-posten din...",
      "redirecting": "Omdirigerer til innloggingssiden...",
      "success": "E-post verifiseret!",
      "error": "Verifisering mislyktes",
    }
  },
  nl: {
    "fields": {
      "username": "Gebruikersnaam",
      "password": "Wachtwoord",
      "email": "E-mailadres",
      "confirmPassword": "Wachtwoord bevestigen",
      "currentPassword": "Huidig wachtwoord",
      "newPassword": "Nieuw wachtwoord",
      "confirmNewPassword": "Nieuw wachtwoord bevestigen"
    },
    "actions": {
      "login": "Inloggen",
      "register": "Registreren",
      "logout": "Uitloggen",
      "changePassword": "Wachtwoord wijzigen",
      "forgotPassword": "Wachtwoord vergeten",
      "resetPassword": "Wachtwoord resetten",
      "sendResetLink": "Reset-link verzenden",
      "forgotUsername": "Gebruikersnaam vergeten",
      "sendUsername": "Gebruikersnaam herinnering verzenden",
      "resendVerification": "Verificatie-e-mail Opnieuw Verzenden",
      "sendVerificationEmail": "Verificatie-e-mail Verzenden",
      "backToLogin": "Terug naar Inloggen",
      "tryAgain": "Probeer Opnieuw",
      "resending": "Verzenden..."
    },
    "messages": {
      "loggingIn": "Inloggen...",
      "loginSuccess": "Succesvol ingelogd",
      "loginError": "Inloggen mislukt",
      "registerSuccess": "Registratie succesvol",
      "registerError": "Registratie mislukt",
      "passwordMismatch": "Wachtwoorden komen niet overeen",
      "passwordChanged": "Wachtwoord succesvol gewijzigd",
      "invalidCredentials": "Ongeldige inloggegevens",
      "pleaseLogin": "Log in om door te gaan",
      "checkEmail": "Controleer je e-mail om je account te verifiëren.",
      "checkSpam": "Als je de e-mail niet ziet in je inbox, controleer dan je spam/ongewenste post map.",
      "registrationSuccess": "Registratie succesvol! Controleer je e-mail om je account te verifiëren.",
      "emailSendFailed": "Registratie succesvol, maar er was een probleem bij het verzenden van de verificatie-e-mail. Neem contact op met de support.",
      "passwordResetSent": "Als je e-mailadres geregistreerd is, ontvang je instructies om je wachtwoord te resetten.",
      "passwordResetSuccess": "Wachtwoord reset succesvol. Je kunt nu inloggen met je nieuwe wachtwoord.",
      "usernameReminderSent": "Als je e-mailadres geregistreerd is, ontvang je een e-mail met je gebruikersnaam.",
      "verificationNote": "Het kan tot 30 minuten duren voordat je de verificatie-e-mail ontvangt. Als je deze binnen deze tijd niet ontvangt, controleer dan je spam/ongewenste post map. Als de e-mail daar niet staat, overweeg dan een alternatief e-mailadres. Als het probleem aanhoudt, neem contact met ons op via contact@qualitati.com.",
      "resendVerificationInstructions": "Voer uw e-mailadres in en we sturen u een nieuwe verificatielink. Controleer uw spammap.",
      "resendFailed": "Kan verificatie-e-mail niet opnieuw verzenden. Probeer het later opnieuw.",
      "incorrectCredentials": "Onjuiste gebruikersnaam/e-mail of wachtwoord. Probeer het opnieuw.",
      "emailNotVerified": "Verifieer uw e-mail voordat u inlogt.",
      "mfaPrompt": "We hebben je een 6-cijferige code gemaild. Voer deze hieronder in om in te loggen.",
      "mfaCodeLabel": "Verificatiecode",
      "mfaVerify": "Code verifiëren",
      "mfaBack": "Terug naar inloggen",
      "mfaVerifying": "Verifiëren...",
      "mfaInvalid": "Ongeldige of verlopen code. Probeer het opnieuw."
    },
    "verification": {
      "verifying": "Je e-mail verifiëren...",
      "redirecting": "Doorverwijzen naar inlogpagina...",
      "success": "E-mail verificatie succesvol!",
      "error": "Verificatie mislukt",
    }
  },
  de: {
    "fields": {
      "username": "Benutzername",
      "password": "Passwort",
      "email": "E-Mail",
      "confirmPassword": "Passwort bestätigen",
      "currentPassword": "Aktuelles Passwort",
      "newPassword": "Neues Passwort",
      "confirmNewPassword": "Neues Passwort bestätigen"
    },
    "actions": {
      "login": "Anmelden",
      "register": "Registrieren",
      "logout": "Abmelden",
      "changePassword": "Passwort ändern",
      "forgotPassword": "Passwort vergessen",
      "resetPassword": "Passwort zurücksetzen",
      "sendResetLink": "Reset-Link senden",
      "forgotUsername": "Benutzername vergessen",
      "sendUsername": "Benutzername-Erinnerung senden",
      "resendVerification": "Bestätigungs-E-Mail Erneut Senden",
      "sendVerificationEmail": "Bestätigungs-E-Mail Senden",
      "backToLogin": "Zurück zur Anmeldung",
      "tryAgain": "Erneut Versuchen",
      "resending": "Wird gesendet..."
    },
    "messages": {
      "loggingIn": "Anmelden...",
      "loginSuccess": "Anmeldung erfolgreich",
      "loginError": "Anmeldung fehlgeschlagen",
      "registerSuccess": "Registrierung erfolgreich",
      "registerError": "Registrierung fehlgeschlagen",
      "passwordMismatch": "Passwörter stimmen nicht überein",
      "passwordChanged": "Passwort erfolgreich geändert",
      "invalidCredentials": "Ungültige Anmeldedaten",
      "pleaseLogin": "Bitte melden Sie sich an, um fortzufahren",
      "checkEmail": "Bitte überprüfen Sie Ihre E-Mail, um Ihr Konto zu verifizieren.",
      "checkSpam": "Wenn Sie die E-Mail nicht in Ihrem Posteingang sehen, überprüfen Sie bitte Ihren Spam-/Junk-Ordner.",
      "registrationSuccess": "Registrierung erfolgreich! Bitte überprüfen Sie Ihre E-Mail, um Ihr Konto zu verifizieren.",
      "emailSendFailed": "Registrierung erfolgreich, aber es gab ein Problem beim Senden der Bestätigungs-E-Mail. Bitte kontaktieren Sie den Support.",
      "passwordResetSent": "Wenn Ihre E-Mail registriert war, erhalten Sie Anweisungen zum Zurücksetzen Ihres Passworts.",
      "passwordResetSuccess": "Passwort-Zurücksetzung erfolgreich. Sie können sich jetzt mit Ihrem neuen Passwort anmelden.",
      "usernameReminderSent": "Wenn Ihre E-Mail registriert war, erhalten Sie eine E-Mail mit Ihrem Benutzernamen.",
      "verificationNote": "Bitte beachten Sie, dass es bis zu 30 Minuten dauern kann, die Bestätigungs-E-Mail zu erhalten. Wenn Sie sie innerhalb dieses Zeitrahmens nicht erhalten, überprüfen Sie bitte Ihren Spam- oder Junk-Ordner. Wenn die E-Mail dort nicht ist, erwägen Sie die Verwendung einer alternativen E-Mail-Adresse. Sollte das Problem weiterhin bestehen, kontaktieren Sie uns unter contact@qualitati.com.",
      "resendVerificationInstructions": "Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen neuen Bestätigungslink. Überprüfen Sie unbedingt Ihren Spam-Ordner.",
      "resendFailed": "Fehler beim erneuten Senden der Bestätigungs-E-Mail. Bitte versuchen Sie es später erneut.",
      "incorrectCredentials": "Falscher Benutzername/E-Mail oder Passwort. Bitte versuchen Sie es erneut.",
      "emailNotVerified": "Bitte bestätigen Sie Ihre E-Mail, bevor Sie sich anmelden.",
      "mfaPrompt": "Wir haben Ihnen einen 6-stelligen Code per E-Mail gesendet. Geben Sie ihn unten ein, um die Anmeldung abzuschließen.",
      "mfaCodeLabel": "Bestätigungscode",
      "mfaVerify": "Code bestätigen",
      "mfaBack": "Zurück zur Anmeldung",
      "mfaVerifying": "Wird überprüft...",
      "mfaInvalid": "Ungültiger oder abgelaufener Code. Bitte versuchen Sie es erneut."
    },
    "verification": {
      "verifying": "Ihre E-Mail wird verifiziert...",
      "redirecting": "Weiterleitung zur Anmeldeseite...",
      "success": "E-Mail-Verifizierung erfolgreich!",
      "error": "Verifizierung fehlgeschlagen",
    }
  },
  es: {
    "fields": {
      "username": "Nombre de usuario",
      "password": "Contraseña",
      "email": "Correo electrónico",
      "confirmPassword": "Confirmar contraseña",
      "currentPassword": "Contraseña actual",
      "newPassword": "Nueva contraseña",
      "confirmNewPassword": "Confirmar nueva contraseña"
    },
    "actions": {
      "login": "Iniciar sesión",
      "register": "Registrarse",
      "logout": "Cerrar sesión",
      "changePassword": "Cambiar contraseña",
      "forgotPassword": "Olvidé mi contraseña",
      "resetPassword": "Restablecer contraseña",
      "sendResetLink": "Enviar enlace de restablecimiento",
      "forgotUsername": "Olvidé mi nombre de usuario",
      "sendUsername": "Enviar recordatorio de nombre de usuario",
      "resendVerification": "Reenviar Correo de Verificación",
      "sendVerificationEmail": "Enviar Correo de Verificación",
      "backToLogin": "Volver al Inicio de Sesión",
      "tryAgain": "Intentar de Nuevo",
      "resending": "Enviando..."
    },
    "messages": {
      "loggingIn": "Iniciando sesión...",
      "loginSuccess": "Inicio de sesión exitoso",
      "loginError": "Error en el inicio de sesión",
      "registerSuccess": "Registro exitoso",
      "registerError": "Error en el registro",
      "passwordMismatch": "Las contraseñas no coinciden",
      "passwordChanged": "Contraseña cambiada exitosamente",
      "invalidCredentials": "Credenciales inválidas",
      "pleaseLogin": "Por favor, inicie sesión para continuar",
      "checkEmail": "Por favor, verifique su correo electrónico para verificar su cuenta.",
      "checkSpam": "Si no ve el correo en su bandeja de entrada, por favor verifique su carpeta de spam/correo no deseado.",
      "registrationSuccess": "¡Registro exitoso! Por favor, verifique su correo electrónico para verificar su cuenta.",
      "emailSendFailed": "Registro exitoso, pero hubo un problema enviando el correo de verificación. Por favor, contacte soporte.",
      "passwordResetSent": "Si su correo electrónico estaba registrado, recibirá instrucciones para restablecer su contraseña.",
      "passwordResetSuccess": "Restablecimiento de contraseña exitoso. Ahora puede iniciar sesión con su nueva contraseña.",
      "usernameReminderSent": "Si su correo electrónico estaba registrado, recibirá un correo con su nombre de usuario.",
      "verificationNote": "Tenga en cuenta que puede tomar hasta 30 minutos recibir el correo de verificación. Si no lo recibe dentro de este tiempo, por favor verifique su carpeta de spam o correo no deseado. Si el correo no está allí, considere usar una dirección de correo electrónico alternativa. Si el problema persiste, contáctenos en contact@qualitati.com.",
      "resendVerificationInstructions": "Ingrese su dirección de correo electrónico y le enviaremos un nuevo enlace de verificación. Asegúrese de verificar su carpeta de spam.",
      "resendFailed": "Error al reenviar el correo de verificación. Por favor, inténtelo de nuevo más tarde.",
      "incorrectCredentials": "Nombre de usuario/correo o contraseña incorrectos. Por favor, inténtelo de nuevo.",
      "emailNotVerified": "Por favor, verifique su correo electrónico antes de iniciar sesión.",
      "mfaPrompt": "Te hemos enviado un código de 6 dígitos por correo. Introdúcelo abajo para completar el inicio de sesión.",
      "mfaCodeLabel": "Código de verificación",
      "mfaVerify": "Verificar código",
      "mfaBack": "Volver al inicio de sesión",
      "mfaVerifying": "Verificando...",
      "mfaInvalid": "Código no válido o caducado. Inténtalo de nuevo."
    },
    "verification": {
      "verifying": "Verificando su correo electrónico...",
      "redirecting": "Redirigiendo a la página de inicio de sesión...",
      "success": "¡Verificación de correo electrónico exitosa!",
      "error": "Verificación fallida",
    }
  },
  pt: {
    "fields": {
      "username": "Nome de usuário",
      "password": "Senha",
      "email": "E-mail",
      "confirmPassword": "Confirmar senha",
      "currentPassword": "Senha atual",
      "newPassword": "Nova senha",
      "confirmNewPassword": "Confirmar nova senha"
    },
    "actions": {
      "login": "Entrar",
      "register": "Registrar",
      "logout": "Sair",
      "changePassword": "Alterar senha",
      "forgotPassword": "Esqueci minha senha",
      "resetPassword": "Redefinir senha",
      "sendResetLink": "Enviar link de redefinição",
      "forgotUsername": "Esqueci meu nome de usuário",
      "sendUsername": "Enviar lembrete de nome de usuário",
      "resendVerification": "Reenviar E-mail de Verificação",
      "sendVerificationEmail": "Enviar E-mail de Verificação",
      "backToLogin": "Voltar ao Login",
      "tryAgain": "Tentar Novamente",
      "resending": "Enviando..."
    },
    "messages": {
      "loggingIn": "Entrando...",
      "loginSuccess": "Login realizado com sucesso",
      "loginError": "Falha no login",
      "registerSuccess": "Registro realizado com sucesso",
      "registerError": "Falha no registro",
      "passwordMismatch": "As senhas não coincidem",
      "passwordChanged": "Senha alterada com sucesso",
      "invalidCredentials": "Credenciais inválidas",
      "pleaseLogin": "Por favor, faça login para continuar",
      "checkEmail": "Por favor, verifique seu e-mail para verificar sua conta.",
      "checkSpam": "Se não encontrar o e-mail na caixa de entrada, verifique a pasta de spam.",
      "registrationSuccess": "Registro realizado com sucesso! Por favor, verifique seu e-mail para confirmar sua conta.",
      "emailSendFailed": "Registro realizado, mas houve um problema ao enviar o e-mail de verificação. Por favor, entre em contato com o suporte.",
      "passwordResetSent": "Se o seu e-mail estiver registrado, você receberá instruções para redefinir a senha.",
      "passwordResetSuccess": "Senha redefinida com sucesso. Você já pode fazer login com a nova senha.",
      "usernameReminderSent": "Se o seu e-mail estiver registrado, você receberá um e-mail com seu nome de usuário.",
      "verificationNote": "O e-mail de verificação pode levar até 30 minutos para chegar. Se não receber, verifique a pasta de spam. Se o problema persistir, entre em contato em contact@qualitati.com.",
      "resendVerificationInstructions": "Digite seu e-mail e enviaremos um novo link de verificação. Verifique também a pasta de spam.",
      "resendFailed": "Falha ao reenviar o e-mail de verificação. Tente novamente mais tarde.",
      "incorrectCredentials": "Nome de utilizador/e-mail ou palavra-passe incorretos. Tente novamente.",
      "emailNotVerified": "Por favor, verifique o seu e-mail antes de iniciar sessão.",
      "mfaPrompt": "Enviámos um código de 6 dígitos para o seu e-mail. Introduza-o abaixo para concluir o início de sessão.",
      "mfaCodeLabel": "Código de verificação",
      "mfaVerify": "Verificar código",
      "mfaBack": "Voltar ao início de sessão",
      "mfaVerifying": "A verificar...",
      "mfaInvalid": "Código inválido ou expirado. Tente novamente."
    },
    "verification": {
      "verifying": "Verificando seu e-mail...",
      "redirecting": "Redirecionando para a página de login...",
      "success": "E-mail verificado com sucesso!",
      "error": "Falha na verificação",
    }
  },
  ja: {
    "fields": {
      "username": "ユーザー名",
      "password": "パスワード",
      "email": "メールアドレス",
      "confirmPassword": "パスワードを確認",
      "currentPassword": "現在のパスワード",
      "newPassword": "新しいパスワード",
      "confirmNewPassword": "新しいパスワードを確認"
    },
    "actions": {
      "login": "ログイン",
      "register": "登録",
      "logout": "ログアウト",
      "changePassword": "パスワードを変更",
      "forgotPassword": "パスワードを忘れた",
      "resetPassword": "パスワードをリセット",
      "sendResetLink": "リセットリンクを送信",
      "forgotUsername": "ユーザー名を忘れた",
      "sendUsername": "ユーザー名リマインダーを送信",
      "resendVerification": "確認メールを再送信",
      "sendVerificationEmail": "確認メールを送信",
      "backToLogin": "ログインに戻る",
      "tryAgain": "再試行",
      "resending": "送信中..."
    },
    "messages": {
      "loggingIn": "ログイン中...",
      "loginSuccess": "ログインに成功しました",
      "loginError": "ログインに失敗しました",
      "registerSuccess": "登録に成功しました",
      "registerError": "登録に失敗しました",
      "passwordMismatch": "パスワードが一致しません",
      "passwordChanged": "パスワードが正常に変更されました",
      "invalidCredentials": "認証情報が無効です",
      "pleaseLogin": "続けるにはログインしてください",
      "checkEmail": "アカウントを確認するためにメールを確認してください。",
      "checkSpam": "受信トレイにメールが見当たらない場合は、迷惑メールフォルダを確認してください。",
      "registrationSuccess": "登録に成功しました！アカウントを確認するためにメールを確認してください。",
      "emailSendFailed": "登録は成功しましたが、確認メールの送信に問題が発生しました。サポートにお問い合わせください。",
      "passwordResetSent": "メールアドレスが登録されている場合、パスワードリセットの手順を受け取ります。",
      "passwordResetSuccess": "パスワードのリセットに成功しました。新しいパスワードでログインできます。",
      "usernameReminderSent": "メールアドレスが登録されている場合、ユーザー名が記載されたメールを受け取ります。",
      "verificationNote": "確認メールは最大30分かかる場合があります。受け取れない場合は迷惑メールフォルダを確認してください。問題が解決しない場合は contact@qualitati.com にお問い合わせください。",
      "resendVerificationInstructions": "メールアドレスを入力すると、新しい確認リンクを送信します。迷惑メールフォルダも確認してください。",
      "resendFailed": "確認メールの再送信に失敗しました。後でもう一度お試しください。",
      "incorrectCredentials": "ユーザー名/メールアドレスまたはパスワードが正しくありません。もう一度お試しください。",
      "emailNotVerified": "ログインする前にメールアドレスを確認してください。",
      "mfaPrompt": "6桁の確認コードをメールで送信しました。ログインを完了するには以下に入力してください。",
      "mfaCodeLabel": "確認コード",
      "mfaVerify": "コードを確認",
      "mfaBack": "ログインに戻る",
      "mfaVerifying": "確認中...",
      "mfaInvalid": "コードが無効または期限切れです。もう一度お試しください。"
    },
    "verification": {
      "verifying": "メールを確認中...",
      "redirecting": "ログインページへリダイレクト中...",
      "success": "メール確認に成功しました！",
      "error": "確認に失敗しました",
    }
  },
  ar: {
    "fields": {
      "username": "اسم المستخدم",
      "password": "كلمة المرور",
      "email": "البريد الإلكتروني",
      "confirmPassword": "تأكيد كلمة المرور",
      "currentPassword": "كلمة المرور الحالية",
      "newPassword": "كلمة المرور الجديدة",
      "confirmNewPassword": "تأكيد كلمة المرور الجديدة"
    },
    "actions": {
      "login": "تسجيل الدخول",
      "register": "التسجيل",
      "logout": "تسجيل الخروج",
      "changePassword": "تغيير كلمة المرور",
      "forgotPassword": "نسيت كلمة المرور",
      "resetPassword": "إعادة تعيين كلمة المرور",
      "sendResetLink": "إرسال رابط إعادة التعيين",
      "forgotUsername": "نسيت اسم المستخدم",
      "sendUsername": "إرسال تذكير باسم المستخدم",
      "resendVerification": "إعادة إرسال بريد التحقق",
      "sendVerificationEmail": "إرسال بريد التحقق",
      "backToLogin": "العودة إلى تسجيل الدخول",
      "tryAgain": "حاول مجدداً",
      "resending": "جار الإرسال..."
    },
    "messages": {
      "loggingIn": "جاري تسجيل الدخول...",
      "loginSuccess": "تم تسجيل الدخول بنجاح",
      "loginError": "فشل تسجيل الدخول",
      "registerSuccess": "تم التسجيل بنجاح",
      "registerError": "فشل التسجيل",
      "passwordMismatch": "كلمات المرور غير متطابقة",
      "passwordChanged": "تم تغيير كلمة المرور بنجاح",
      "invalidCredentials": "بيانات الاعتماد غير صالحة",
      "pleaseLogin": "يرجى تسجيل الدخول للمتابعة",
      "checkEmail": "يرجى التحقق من بريدك الإلكتروني للتحقق من حسابك.",
      "checkSpam": "إذا لم تجد البريد في صندوق الوارد، يرجى التحقق من مجلد الرسائل غير المرغوب فيها.",
      "registrationSuccess": "تم التسجيل بنجاح! يرجى التحقق من بريدك الإلكتروني للتحقق من حسابك.",
      "emailSendFailed": "تم التسجيل، لكن حدثت مشكلة في إرسال بريد التحقق. يرجى التواصل مع الدعم.",
      "passwordResetSent": "إذا كان بريدك الإلكتروني مسجلاً، ستتلقى تعليمات لإعادة تعيين كلمة المرور.",
      "passwordResetSuccess": "تمت إعادة تعيين كلمة المرور بنجاح. يمكنك الآن تسجيل الدخول بكلمة المرور الجديدة.",
      "usernameReminderSent": "إذا كان بريدك الإلكتروني مسجلاً، ستتلقى بريداً يحتوي على اسم مستخدمك.",
      "verificationNote": "قد يستغرق وصول بريد التحقق ما يصل إلى 30 دقيقة. إذا لم تستلمه، تحقق من مجلد الرسائل غير المرغوب فيها. إذا استمرت المشكلة، تواصل معنا على contact@qualitati.com.",
      "resendVerificationInstructions": "أدخل بريدك الإلكتروني وسنرسل لك رابط تحقق جديداً. تأكد من التحقق من مجلد الرسائل غير المرغوب فيها.",
      "resendFailed": "فشل إعادة إرسال بريد التحقق. يرجى المحاولة مرة أخرى لاحقاً.",
      "incorrectCredentials": "اسم المستخدم/البريد الإلكتروني أو كلمة المرور غير صحيحة. يرجى المحاولة مرة أخرى.",
      "emailNotVerified": "يرجى التحقق من بريدك الإلكتروني قبل تسجيل الدخول.",
      "mfaPrompt": "أرسلنا إليك رمزًا مكوّنًا من 6 أرقام عبر البريد الإلكتروني. أدخله أدناه لإكمال تسجيل الدخول.",
      "mfaCodeLabel": "رمز التحقق",
      "mfaVerify": "تحقق من الرمز",
      "mfaBack": "العودة إلى تسجيل الدخول",
      "mfaVerifying": "جارٍ التحقق...",
      "mfaInvalid": "رمز غير صالح أو منتهي الصلاحية. حاول مرة أخرى."
    },
    "verification": {
      "verifying": "جار التحقق من بريدك الإلكتروني...",
      "redirecting": "جار إعادة التوجيه إلى صفحة تسجيل الدخول...",
      "success": "تم التحقق من البريد الإلكتروني بنجاح!",
      "error": "فشل التحقق",
    }
  }
};
